module.exports = __webpack_public_path__ + "img/bridge-width-3.45c6924.svg?v=1761300065174";